import React, { useEffect, useState } from 'react';
import { Card } from '@thd-olt-component-react/card';
import { ProductInfoBar } from '@thd-olt-component-react/product-info-bar';
import { Row } from '@thd-olt-component-react/grid';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { PreviewContent } from './components/PreviewContent/PreviewContent';
import { MobileContent } from './components/MobileContent/MobileContent';
import { QuickLinks } from './components/QuickLinks/QuickLinks';
import { DownloadAdobe } from './components/DownloadAdobe/DownloadAdobe';
import {
  defaultThemeProperties,
  getBullets,
  isEventBusCreated,
  isRichContentExpandable, productOverviewDefaultProps,
  productOverviewPropTypes,
  setRichContentExpandable,
  themeProperties,
  triggerCardClick
} from './helpers';
import { Highlights } from './components/Highlights/Highlights';
import { RichContent } from './components/RichContent/RichContent';
import { dataModel } from './dataModel';

let setRichContentExpandableTimer = null;

const removeRichContentExpandableTimer = () => {
  clearInterval(setRichContentExpandableTimer);
};
export const ProductOverviewMobile = (props) => {
  const {
    headingTitle,
    itemId,
    showRichContentsOnly,
    quickLinks,
    hideRichContents,
    preview,
    showReturnMessage,
    revJet
  } = props;
  const richContentsOnlyRef = React.createRef();
  const [shouldShowMore, setShouldShowMore] = useState(false);
  const { data, loading } = useDataModel('product', { variables: { itemId } });
  const theme = useTheme(ProductOverviewMobile, {
    itemId, showRichContentsOnly, quickLinks, hideRichContents, preview
  });
  const { showUpcCode } = theme?.props || {};
  const richContentsOnlyOnImageComplete = () => {
    removeRichContentExpandableTimer();
    if (isRichContentExpandable(richContentsOnlyRef)) {
      setShouldShowMore(true);
    }
  };

  useEffect(() => {
    setRichContentExpandable({
      ref: richContentsOnlyRef,
      timer: setRichContentExpandableTimer,
      richContentsOnlyOnImageComplete,
      removeRichContentExpandableTimer
    });
    if (isEventBusCreated()) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('product-overview.ready', {});
    }
    return () => {
      removeRichContentExpandableTimer();
    };
  }, [itemId]);

  if (loading || !data?.product) {
    return null;
  }

  const {
    modelNumber,
    rentalCategory,
    rentalSubCategory,
    storeSkuNumber,
    upc
  } = data?.product?.identifiers || {};
  const {
    richContent
  } = data?.product?.media || {};
  const {
    prop65Warning,
    returnable
  } = data?.product?.info || {};

  const {
    description,
    highlights,
    infoAndGuides: documents,
    descriptiveAttributes
  } = data?.product?.details || {};

  const bullets = getBullets({
    channel: 'mobile',
    descriptiveAttributes,
    showRichContentsOnly,
    showReturnMessage,
    prop65Warning,
    returnable
  });

  // todo: use in sub component as needed instead of passing in.
  const renderedHighlights = (
    <Highlights
      hideRichContents={hideRichContents}
      highlights={highlights}
      showRichContentsOnly={showRichContentsOnly}
    />
  );

  // todo: where is this used? Should be implemented as standalone
  if (showRichContentsOnly) {
    return (
      <RichContent
        itemId={itemId}
        revJet={revJet}
        description={description}
        documents={documents}
        richContent={richContent}
        bullets={bullets}
        showRichContentsOnly={showRichContentsOnly}
        hideRichContents={hideRichContents}
        preview={preview}
        shouldShowMore={shouldShowMore}
        richContentsOnlyRef={richContentsOnlyRef}
        setShouldShowMore={setShouldShowMore}
        channel="mobile"
      />
    );
  }

  return (
    <div
      className="grid pip-row section product-overview"
      data-section="product-overview"
    >
      <Card getOnClick={triggerCardClick}>
        <Card.Content title={headingTitle} fade>
          {(highlights || description) && (
            <PreviewContent highlights={highlights ? renderedHighlights : description} />
          )}
          <Card.Content.Overlay>
            <MobileContent
              description={description}
              documents={documents}
              highlights={renderedHighlights}
              itemId={itemId}
              modelNumber={modelNumber}
              storeSkuNumber={storeSkuNumber}
              rentalCategory={rentalCategory}
              rentalSubCategory={rentalSubCategory}
              bullets={bullets}
              showRichContentsOnly={showRichContentsOnly}
              hideRichContents={hideRichContents}
              upc={upc}
              showUpcCode={showUpcCode}
              channel="mobile"
              returnMessage={returnable}
              showReturnMessage={showReturnMessage}
            />
          </Card.Content.Overlay>
        </Card.Content>
        <Card.Footer className="product-overview__model-information" hideTopBorder>
          <ProductInfoBar itemId={itemId} showOnMobile />
        </Card.Footer>
        {quickLinks && (
          <Card.Footer className="product-overview__quick-links" hideTopBorder>
            <Row className="product-overview__quick-links-block flush">
              {' '}
              <QuickLinks itemId={itemId} />
              {' '}
            </Row>
            <DownloadAdobe />
          </Card.Footer>
        )}
        {!quickLinks && !!documents?.length
        && (
          <Card.Footer
            className="product-overview__mobile-footer"
            triggerFor="default-overlay"
            scrollToBottom
            hideTopBorder
          >
            <span className="product-overview__mobile-footer-link bttn--link">Info &amp; Guides</span>
          </Card.Footer>
        )}
      </Card>
    </div>
  );
};

ProductOverviewMobile.displayName = 'ProductOverviewMobile';

ProductOverviewMobile.dataModel = dataModel;

ProductOverviewMobile.themeProps = themeProperties;

ProductOverviewMobile.defaultThemeProps = defaultThemeProperties;

ProductOverviewMobile.propTypes = productOverviewPropTypes;

ProductOverviewMobile.defaultProps = productOverviewDefaultProps;
